import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';
import get from 'lodash.get';

import { AppState } from 'services/types';
import { FertilizerProductId } from 'services/fertilizerEvents/types';
import { OwnProps } from './index';
import { selectFertilizerWorksheetProductsKeyedById } from '../../../../selectors';

const selectProductId = (
    state: AppState,
    props: OwnProps
): FertilizerProductId => props.productId;

const selectProductName = createDeepEqualSelector(
    selectFertilizerWorksheetProductsKeyedById,
    selectProductId,
    (productsKeyedById, productId) =>
        get(productsKeyedById, [productId, 'fertilizerProduct', 'name'])
);

const makeSelectProductName = (): typeof selectProductName => selectProductName;

export { selectProductId, makeSelectProductName };
